
namespace RioERP.Shipping {
    export class ShippingRulesColumns {
        static columnsKey = 'Shipping.ShippingRules';
    }
}